import { render } from "./ScheduleStatistics.vue?vue&type=template&id=e5664fde"
import script from "./ScheduleStatistics.vue?vue&type=script&lang=js"
export * from "./ScheduleStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__